import { tasksApi } from './tasks';

export const mapExistingFilesToUploadList = (files) => {
    if (!Array.isArray(files)) return [];
    return files.map(f => ({
        uid: `existing-${f.id}`,
        name: f.name,
        status: 'done',
    }));
};

export const getExistingFilesUploadList = async (taskId) => {
    const files = await tasksApi.getTaskFiles(taskId);
    return mapExistingFilesToUploadList(files);
};

export const getFilesFromForm = (materials) => {
    if (!Array.isArray(materials)) return [];
    return materials
        .filter(item => item && item.originFileObj)
        .map(item => item.originFileObj);
};

export const getNewFilesExcludingExisting = (materials, existingUploadList) => {
    const existingNames = new Set((existingUploadList || []).map(f => f.name));
    if (!Array.isArray(materials)) return [];
    return materials
        .filter(item => item && item.originFileObj && !existingNames.has(item.name))
        .map(item => item.originFileObj);
};

export const uploadTaskFiles = async (taskId, files) => {
    if (!taskId || !Array.isArray(files) || files.length === 0) return;
    await Promise.all(files.map(file => tasksApi.uploadTaskFile(taskId, file)));
};


